import { RetryIcon_24 } from 'assets/icons';
import Button from 'components/Button';
import Paper from 'components/Paper';
import messages from './ErrorLoader.messages';
import styles from './ErrorLoader.module.css';

type Props = {
  refetch: VoidFunction;
  isRefetching: boolean;
};

const ErrorLoader = ({ refetch, isRefetching }: Props): JSX.Element => (
  <Paper>
    <h3 className={styles.errorLoader__title}>{messages.title}</h3>
    <Button
      className={styles.errorLoader__button}
      onClick={refetch}
      isLoading={isRefetching}
    >
      <RetryIcon_24 />
      {messages.retry}
    </Button>
  </Paper>
);

export default ErrorLoader;
